import {Directive, OnInit, OnDestroy} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {APPCONFIG} from '../../config';
import {Subscription} from 'rxjs';

// Mobile only: automatically close sidebar on route change.
@Directive({
  selector: '[myAutoCloseMobileNav]',
  standalone: false,
})
export class AutoCloseMobileNavDirective implements OnInit, OnDestroy {
  private routerSubscription: Subscription | null = null;

  constructor(private router: Router) {}

  ngOnInit() {
    if (APPCONFIG.AutoCloseMobileNav) {
      this.routerSubscription = this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            // console.log('NavigationEnd:', event);
            const body = document.getElementById('body');
            if (body) {
              body.classList.remove('sidebar-mobile-open');
            }
          }, 0);
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
